import Pill, { type PillColor } from '@/shared/components/flip-ui-kit/Pill';

export const PoolFeeBadge = ({
  liquidityFeeHundredthPips,
  color = 'neutral',
}: {
  liquidityFeeHundredthPips: number;
  color?: PillColor;
}) => (
  <Pill
    tooltipContent="Fixed Liquidity Provider fee for this pool"
    color={color}
    text={`${(liquidityFeeHundredthPips / 10_000).toString()}%`}
  />
);
